export class Media {
  constructor(
    public readonly mediaType: 'IMAGE' | 'VIDEO' | 'CAROUSEL_ALBUM',
    public readonly mediaUrl: string | undefined,
    public readonly id: string,
    public readonly children: Media[],
    public readonly thumbnailUrl?: string
  ) {}

  get displayUrl(): string {
    return this.mediaUrl || this.thumbnailUrl || '';
  }

  get isPlayableVideo(): boolean {
    return this.mediaType === 'VIDEO' && Boolean(this.mediaUrl);
  }
}
